import React from 'react';
import { useQueryParams } from 'use-query-params';

import { CommaArrayParam } from '../utils';

import FilterChecklist from '../components/FilterChecklist';
import FilterDropdown from '../components/FilterDropdown';

function updateFilterOptions(activeValues, filterOptions) {
  return activeValues != null
    ? activeValues.map((d) => filterOptions.find((option) => option.name === d))
    : [];
}

const ConversationFilter = ({
  title,
  filterOptions,
  activeOptions,
  setActiveOptions,
  isMobile,
}) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const key = title.toLowerCase();
  const [query, setQuery] = useQueryParams({
    [key]: CommaArrayParam,
  });
  const { [key]: activeValues } = query;

  // set active options from query params
  React.useEffect(() => {
    setActiveOptions(updateFilterOptions(activeValues, filterOptions));
  }, [activeValues]);

  if (filterOptions.length === 0) {
    return null;
  }

  const handleFilterSave = (options) => {
    let query = {};
    query[key] =
      options.length === 0 ? undefined : options.map((option) => option.name);
    setQuery(query, 'pushIn');
    setDropdownOpen(false);
  };

  return (
    <FilterDropdown
      defaultTitle={title}
      filterOptions={filterOptions}
      activeOptions={activeOptions}
      dropdownOpen={dropdownOpen}
      setDropdownOpen={setDropdownOpen}
      isMobile={isMobile}
    >
      <FilterChecklist
        filterOptions={filterOptions}
        activeOptions={activeOptions}
        onSave={(options) => {
          handleFilterSave(options);
        }}
        isMobile={isMobile}
      />
    </FilterDropdown>
  );
};

export default ConversationFilter;
